module.exports = __webpack_public_path__ + "static/media/bienvenida.b3da7cd8.jpg";